export enum EventKey {
    SpanStarted = 'Planet.Analytics.Common.Models.Dto.ClientEvents.SpanStarted',
    SpanEnded = 'Planet.Analytics.Common.Models.Dto.ClientEvents.SpanEnded',
    SpanResumed = 'Planet.Analytics.Common.Models.Dto.ClientEvents.SpanResumed',
    SpanUpdated = 'Planet.Analytics.Common.Models.Dto.ClientEvents.SpanUpdated',
    SpanTimedOut = 'Planet.Analytics.Common.Models.Dto.ClientEvents.SpanTimedOut',

    JavascriptRuntimeError = 'Planet.Analytics.Common.Models.Dto.ClientEvents.JavascriptRuntimeError',

    ClientSessionStarted = 'Planet.Analytics.Common.Models.Dto.ClientEvents.ClientSessionStarted',
    ClientSessionResumed = 'Planet.Analytics.Common.Models.Dto.ClientEvents.ClientSessionResumed',

    BrowsingSessionStarted = 'Planet.Analytics.Common.Models.Dto.ClientEvents.BrowsingSessionStarted',
    BrowsingSessionPaused = 'Planet.Analytics.Common.Models.Dto.ClientEvents.BrowsingSessionPaused',
    BrowsingSessionResumed = 'Planet.Analytics.Common.Models.Dto.ClientEvents.BrowsingSessionResumed',

    PageSessionStarted = 'Planet.Analytics.Common.Models.Dto.ClientEvents.PageSessionStarted',
    PageVisibilityChanged = 'Planet.Analytics.Common.Models.Dto.ClientEvents.PageVisibilityChanged',
    PageSessionEnded = 'Planet.Analytics.Common.Models.Dto.ClientEvents.PageSessionEnded',

    PlayerInstanceCreated = 'Planet.Analytics.Common.Models.Dto.ClientEvents.PlayerInstanceCreated',
    PlayerInstanceDestroyed = 'Planet.Analytics.Common.Models.Dto.ClientEvents.PlayerInstanceDestroyed',
    PlayerInstancePlaybackError = 'Planet.Analytics.Common.Models.Dto.ClientEvents.PlayerInstancePlaybackError',
    PlayerInstanceSetupError = 'Planet.Analytics.Common.Models.Dto.ClientEvents.PlayerInstanceSetupError',
    PlayerInstanceStateChanged = 'Planet.Analytics.Common.Models.Dto.ClientEvents.PlayerInstanceStateChanged',

    PlaybackSessionUpdate = 'Planet.Analytics.Common.Models.Dto.ClientEvents.PlaybackSessionUpdate',
    PlaybackSessionCreated = 'Planet.Analytics.Common.Models.Dto.ClientEvents.PlaybackSessionCreated',
    PlaybackSessionContentLoaded = 'Planet.Analytics.Common.Models.Dto.ClientEvents.PlaybackSessionContentLoaded',
    PlaybackSessionStarted = 'Planet.Analytics.Common.Models.Dto.ClientEvents.PlaybackSessionStarted',
    PlaybackSessionPaused = 'Planet.Analytics.Common.Models.Dto.ClientEvents.PlaybackSessionPaused',
    PlaybackSessionResumed = 'Planet.Analytics.Common.Models.Dto.ClientEvents.PlaybackSessionResumed',
    PlaybackSessionSeeked = 'Planet.Analytics.Common.Models.Dto.ClientEvents.PlaybackSessionSeeked',
    PlaybackSessionEnded = 'Planet.Analytics.Common.Models.Dto.ClientEvents.PlaybackSessionEnded',
}
